import React from 'react';

// Shows a PDF in a fixed-height preview box (using the browser's native PDF
// viewer inside an iframe) instead of letting it take over the page --
// useful for a "kind of large" report where you don't want visitors forced
// to scroll through the whole thing just to see the use case.
const PdfEmbed = ({
  url,
  title = 'Report',
  height = '600px',
  className = ''
}) => {
  if (!url) {
    return null;
  }

  // Chrome's built-in PDF viewer honors a #toolbar=0 URL fragment to hide
  // its own top bar (page controls, zoom, print/download icons) when the
  // PDF is embedded in an iframe -- cleaner for a contained preview box
  // than fighting with the black native toolbar. Firefox/Safari don't
  // honor this and will still show their own toolbar, which is a harmless
  // fallback (their toolbar already has its own open/download/print
  // controls, so nothing is lost there either).
  const previewSrc = `${url}#toolbar=0`;

  // Boxed/scrollable card -- for a multi-page document you WANT contained
  // with its own scrollbar rather than dumping the whole thing into the
  // page. For a single-page document you want fully visible with no
  // scrolling, use PageImage instead (a plain <img>, no PDF viewer
  // involved at all -- see its comments for why).
  return (
    <div className={`w-full overflow-hidden rounded-xl border border-gray-200 shadow-sm ${className}`}>
      <iframe
        src={previewSrc}
        title={title}
        style={{ height, width: '100%', border: 0 }}
        loading="lazy"
      />
    </div>
  );
};

export default PdfEmbed;
